import { render, staticRenderFns } from "./ProfileInterestTags.vue?vue&type=template&id=27cd68d6"
import script from "./ProfileInterestTags.vue?vue&type=script&lang=js"
export * from "./ProfileInterestTags.vue?vue&type=script&lang=js"
import style0 from "./ProfileInterestTags.vue?vue&type=style&index=0&id=27cd68d6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports